import { useCallback, useMemo, useState } from 'react'

import {
  BulkSelection,
  ImportCertificatesHandlers,
} from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable/hooks/useBulkActionsConfig'

import { ParticipantInfo } from './types'

const defaultSelection: BulkSelection = { type: 'manual', ids: [] }

interface BulkImportState {
  isOpen: boolean
  selection: BulkSelection
  participants: ParticipantInfo[]
}

const initialState: BulkImportState = {
  isOpen: false,
  selection: defaultSelection,
  participants: [],
}

export const useImportCertificatesModal = () => {
  const [state, setState] = useState<BulkImportState>(initialState)

  const openForBulkImport = useCallback(
    (selection: BulkSelection, participants: ParticipantInfo[]) => {
      setState({
        isOpen: true,
        selection,
        participants,
      })
    },
    []
  )

  const close = useCallback(() => {
    setState(initialState)
  }, [])

  const importCertificatesHandlers: ImportCertificatesHandlers = useMemo(
    () => ({
      onBulkImport: openForBulkImport,
    }),
    [openForBulkImport]
  )

  return {
    isOpen: state.isOpen,
    selection: state.selection,
    participants: state.participants,
    close,
    importCertificatesHandlers,
  }
}
